<template>
  <v-data-table
    class="transparent"
    :headers="headers"
    :items="documentos"
  >
    <template #[`item.estatus`]="{ item }">
      <v-chip
        label
        :color="getDocumentStatusColor(item.estatus_c3)"
        class="font-weight-bold"
      >
        {{ getDocumentStatusLabel(item.estatus_c3) }}
      </v-chip>
    </template>
    <template #[`item.descargar`]="{ item }">
      <v-btn
        color="green"
        icon
        @click="downloadFile(item.id)"
      >
        <v-icon dark>
          mdi-download
        </v-icon>
      </v-btn>
    </template>
    <template #[`item.acciones`]="{ item }">
      <v-btn
        color="green"
        icon
        @click="updateDocumentStatus(item, true)"
      >
        <v-icon dark>
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        color="red"
        icon
        @click="updateDocumentStatus(item, false)"
      >
        <v-icon dark>
          mdi-cancel
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import updateDocumento from '../../modules/persona/application/updateDocumento';
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';

export default {
  props: {
    documentos: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Archivo',
          align: 'start',
          value: 'nombre',
        },
        {
          text: 'Tipo de documento',
          align: 'start',
          value: 'cat_tipo_documento_id',
        },
        {
          text: 'Fecha del archivo',
          align: 'start',
          value: 'fecha',
        },
        {
          text: 'Observaciones',
          align: 'start',
          value: 'observaciones',
        },
        {
          text: 'Última actualización',
          align: 'start',
          value: 'edited_at',
        },
        {
          text: 'Estatus',
          align: 'start',
          value: 'estatus',
        },
        {
          text: '¿Aprobar documento?',
          align: 'center',
          value: 'acciones',
          sortable: false,
        },
        {
          text: 'Acciones',
          align: 'center',
          value: 'descargar',
        },
      ],
    };
  },

  methods: {
    getDocumentStatusLabel(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'Aprobado' : 'Rechazado';
      }

      return 'Pendiente de revisión';
    },

    getDocumentStatusColor(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'success' : 'red';
      }

      return 'grey';
    },

    async updateDocumentStatus(document, newStatus) {
      const repository = createPersonaApiRepository();
      await updateDocumento(repository, {
        ...document,
        estatus_c3: newStatus,
      });

      const documentIndex = this.documentos.findIndex((doc) => doc.id === document.id);
      this.documentos[documentIndex].estatus_c3 = newStatus;
    },

    async downloadFile(documentId) {
      const repository = createPersonaApiRepository();
      const response = await repository.getDocumentoFile(documentId);
      const file = new File([response.data], crypto.randomUUID(), { type: response.headers['content-type'] });
      const href = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = href;
      link.download = crypto.randomUUID();
      link.click();
      URL.revokeObjectURL(href);
    },
  },
};
</script>
